import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BillReportSummarySearchForm from './BillReportSummarySearchForm';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_FORMAT } from '../../../../config/locale';
import Alert from '../../../common/informative/Alert';
import { ENTER_DATA_TO_SHOW_DATA } from '../../../../config/messages';
import Content from '../../../layout/Content';
import { BILLING_REPORT_SUMMARY_BY_DOCUMENT_PATH } from '../../../../config/paths';
import { getBillingReportSummaryByDocument } from '../../../../actions';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import BillReportSummaryByDocumentResult from './BillReportSummaryByDocumentResult';

export const BillReportSummaryByDocument = ({
  dispatchGetBillingReportSummaryByDocument,
  breadcrumbs,
}) => {
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (formValues) => {
    const fromDate = tzNormalizeDate({
      date: formValues.fromDateString,
      format: DATE_FORMAT,
    });

    const toDate = tzNormalizeDate({
      date: formValues.toDateString,
      format: DATE_FORMAT,
    });

    setSubmitted(true);
    dispatchGetBillingReportSummaryByDocument(fromDate, toDate);
  };

  const title = 'Gestión de Ventas e Ingresos Electrónicos';

  const content = (
    <>
      <BillReportSummarySearchForm
        onSubmit={onSubmit}
        initialValues={{
          fromDateString: tzNormalizeDate(),
          toDateString: tzNormalizeDate(),
        }}
      />

      <hr />

      {!submitted && <Alert message={ENTER_DATA_TO_SHOW_DATA} type="warning" />}

      {submitted && <BillReportSummaryByDocumentResult />}
    </>
  );

  return <Content breadcrumbs={breadcrumbs} title={title} content={content} />;
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Gestión de Ventas e Ingresos Electrónicos',
      href: BILLING_REPORT_SUMMARY_BY_DOCUMENT_PATH,
    },
  ],
});

const mapDispatchToProps = {
  dispatchGetBillingReportSummaryByDocument: getBillingReportSummaryByDocument,
};

BillReportSummaryByDocument.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetBillingReportSummaryByDocument: PropTypes.func.isRequired,
};

BillReportSummaryByDocument.defaultProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BillReportSummaryByDocument);
